import { pipe, prop } from 'ramda';
import { DomainPrivacy, PrivacyVisibility } from 'src/common/types/privacy';

const selectAllSettingsState = prop('settings');

export const selectResetModalIsShowing = pipe(
  selectAllSettingsState,
  prop('resetModal'),
  prop<boolean>('isShowing')
);

export const selectResetModalIsResetting = pipe(
  selectAllSettingsState,
  prop('resetModal'),
  prop<boolean>('isResetting')
);

export const selectPlayerWatermarkLinkIsSaving = pipe(
  selectAllSettingsState,
  prop('player'),
  prop('watermarkLink'),
  prop<boolean>('isLoading')
);

export const selectPlayerWatermarkLinkHasSaved = pipe(
  selectAllSettingsState,
  prop('player'),
  prop('watermarkLink'),
  prop<boolean>('isDone')
);

export const selectPrivacyAllowDownload = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop<boolean>('allow_download')
);

export const selectPrivacyAllowSharing = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop<boolean>('allow_sharing')
);

export const selectPrivacyDomainRestrictions = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop<DomainPrivacy>('domain_restrictions')
);

export const selectPrivacyAllowedDomainValue = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop('allowed_domain'),
  prop<string>('value')
);

export const selectPrivacyAllowedDomainIsSaving = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop('allowed_domain'),
  prop<boolean>('isLoading')
);

export const selectPrivacyAllowedDomainHasSaved = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop('allowed_domain'),
  prop<boolean>('isDone')
);

export const selectPrivacyVisibility = pipe(
  selectAllSettingsState,
  prop('privacy'),
  prop<PrivacyVisibility>('visibility')
);
